import {createAsyncThunk, createSelector, createSlice} from '@reduxjs/toolkit';
import {isEqual} from 'lodash';
import {IFiltersSliceState} from '../../DrilldownDashboardContainer/filters/filtersSlice';
import {RootState} from '../store';
import {getAllClients, getAllCustomerTypes, getWebAppVersion} from './clientsAPI';

export interface IAllClientsAPIResponse {
  values: IClient[];
  ip: {}; 
  status: '';
  client: '';
}
export interface ICustomerTypes{
  id: number; 
  memberName: ''; 
  name: '';
}
export interface ICustomerTypesAPIResponse {
  values: [ICustomerTypes]; 
}
export interface IWebAppVersionResponse{
  deployment: any; 
  major: number; 
  minor: number;
}

interface IClientsState {
  isLoading: boolean;
  apiResponse: IAllClientsAPIResponse;
  allClientData: any;
  customerTypes: any;
  allStatus:'';
  webAppVersion: any;
  selectedClient: IClient;
}

export interface IClient {
  abbr: string
  all_surveys_default_question_qid: string
  all_surveys_default_question_val: string
  allowBaseQuestion: number
  classic_customer: number
  customer_type: string
  default_dashboard: string
  default_page_id: number
  default_questions: null
  default_url: string
  domain: string
  dynamic_age: number
  editcommentcodes: number
  editdetails: number
  enableActionAlertUpdates: number
  enableActionAlerts: number
  enableRankingReports: number
  hasLeadershipInsightsUsers: boolean
  id: number
  latestLoad: null
  name: string
  respondentEmail: null
  respondentName: null
  respondentPhone: null
  restricted: string
  status: number
}

const initialState: IClientsState = {
  isLoading: false,
  apiResponse: {
    values: [], 
    ip: {},
    status: '',
    client: '',
  },
  allClientData:[],
  customerTypes:[],
  allStatus:'',
  webAppVersion: '',
  selectedClient: undefined,
}

export const loadAllClients = createAsyncThunk(
  'allClients/get',
  async (allClientStatus: any) => {
    const response = await getAllClients(allClientStatus);
    return response;
  }
);

export const loadCustomerTypes = createAsyncThunk(
  'customerTypes/get',
  async () => {
    const response = await getAllCustomerTypes();
    return response;
  }
);

export const loadWebbAppVersion = createAsyncThunk(
  'webAppVersion/get',
  async () => {
    const response = await getWebAppVersion();
    return response;
  }
);

export const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    selectClient(state: IClientsState, action) {
      state.selectedClient = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAllClients.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loadAllClients.fulfilled, (state, action) => {
      if (action.payload) {
        state.apiResponse = action.payload;
        state.isLoading = false;
        state.allClientData = state.apiResponse.values;
        state.allStatus = state.apiResponse.status;
      }
    });

    builder.addCase(loadCustomerTypes.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loadCustomerTypes.fulfilled, (state, action) => {
      if (action.payload) {
        state.customerTypes = action.payload;
        state.isLoading = false;
      
      }
    });

    builder.addCase(loadWebbAppVersion.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loadWebbAppVersion.fulfilled, (state, action) => {
      if (action.payload) {
        const version = action.payload
        state.webAppVersion = version.major.toString() + '.' + version.minor.toString() + '.' + version.deployment.toString();
        state.isLoading = false;
      }
    });

  },
})

export const { selectClient } = clientsSlice.actions;
export const selectClientsState = (state: RootState) =>
  state.clients;
export default clientsSlice.reducer;



